import React from 'react';
import { useMalcolmContext } from '../../contexts/MalcolmContext';
import { realFeedCrawler } from '../../lib/real-feed-crawler';

const IntelligenceFeedHeader = ({ onToggleSidebar }) => {
  const { 
    searchQuery, 
    setSearchQuery, 
    activeFilter, 
    setActiveFilter,
    sortBy,
    setSortBy,
    feedItems,
    insights,
    refreshAll
  } = useMalcolmContext();

  const handleExport = () => {
    // TODO: Implement export functionality
    console.log('Export functionality to be implemented');
  };

  const handleSourcesConfig = () => {
    // TODO: Implement sources configuration
    console.log('Sources configuration to be implemented');
  };

  const handleRealCrawl = async () => {
    try {
      console.log('🚀 Starting real feed crawl...');
      const result = await realFeedCrawler.triggerManualCrawl();
      console.log('Crawl result:', result);
      
      // Refresh the feed after crawling
      if (result.success) {
        await refreshAll();
      }
    } catch (error) {
      console.error('Error during real crawl:', error);
    }
  };

  const getFilterCounts = () => {
    if (!feedItems) return {};
    
    return {
      all: feedItems.length,
      high_relevance: feedItems.filter(item => item.relevance_score >= 80).length,
      trending: feedItems.filter(item => item.trending_score >= 70).length,
      beta: feedItems.filter(item => item.tags?.includes('beta_access')).length
    };
  };

  const filterCounts = getFilterCounts();
  const unreadInsights = insights.filter(i => !i.is_dismissed).length;

  return (
    <div className="bg-white border-b border-stone-200 sticky top-0 z-50 backdrop-blur-sm bg-white/95">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Left side - Title and meta */}
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-gradient-to-br from-indigo-500 to-teal-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-semibold text-sm">🧠</span>
              </div>
              <div>
                <h1 className="text-lg font-bold text-slate-900">AI Intel</h1>
``              </div>
            </div>
            
            {/* Live indicator */}
            <div className="flex items-center space-x-2 text-sm text-stone-500">
              <div className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></div>
              <span>Live</span>
            </div>
          </div>

          {/* Right side - Actions */}
          <div className="flex items-center space-x-3">
            {/* Search */}
            <div className="relative">
              <input
                type="text"
                placeholder="Search feed..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-64 pl-10 pr-4 py-2 border border-stone-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              />
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg className="h-4 w-4 text-stone-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
              {searchQuery && (
                <button
                  onClick={() => setSearchQuery('')}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center"
                >
                  <svg className="h-4 w-4 text-stone-400 hover:text-stone-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              )}
            </div>

            {/* Sort dropdown */}
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="border border-stone-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
              <option value="relevance">Sort by Relevance</option>
              <option value="date">Sort by Date</option>
              <option value="trending">Sort by Trending</option>
            </select>

            {/* Action buttons */}
            <button
              onClick={handleSourcesConfig}
              className="flex items-center space-x-2 px-3 py-2 border border-stone-300 rounded-lg text-sm font-medium text-stone-700 hover:bg-stone-50 transition-colors"
            >
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span>Sources</span>
            </button>

            <button
              onClick={refreshAll}
              className="flex items-center space-x-2 px-3 py-2 border border-stone-300 rounded-lg text-sm font-medium text-stone-700 hover:bg-stone-50 transition-colors"
            >
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
              <span>Refresh</span>
            </button>

            <button
              onClick={handleRealCrawl}
              className="flex items-center space-x-2 px-3 py-2 bg-teal-600 text-white rounded-lg text-sm font-medium hover:bg-teal-700 transition-colors"
            >
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
              </svg>
              <span>Crawl Real Data</span>
            </button>

            <button
              onClick={handleExport}
              className="flex items-center space-x-2 px-4 py-2 bg-indigo-600 text-white rounded-lg text-sm font-medium hover:bg-indigo-700 transition-colors"
            >
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <span>Export</span>
            </button>

            {/* Sidebar toggle for mobile */}
            <button
              onClick={onToggleSidebar}
              className="lg:hidden flex items-center justify-center w-10 h-10 border border-stone-300 rounded-lg text-stone-700 hover:bg-stone-50 transition-colors"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>

        {/* Filter tabs */}
        <div className="flex items-center space-x-1 py-3 border-t border-stone-100">
          <div className="flex space-x-1">
            {[
              { key: 'all', label: 'All Sources', count: filterCounts.all },
              { key: 'high_relevance', label: 'High Relevance', count: filterCounts.high_relevance },
              { key: 'trending', label: 'Trending', count: filterCounts.trending },
              { key: 'beta', label: 'Beta Access', count: filterCounts.beta }
            ].map((filter) => (
              <button
                key={filter.key}
                onClick={() => setActiveFilter(filter.key)}
                className={`
                  px-4 py-2 rounded-full text-sm font-medium transition-colors
                  ${activeFilter === filter.key
                    ? 'bg-indigo-600 text-white'
                    : 'bg-stone-100 text-stone-700 hover:bg-stone-200'
                  }
                `}
              >
                {filter.label}
                {filter.count > 0 && (
                  <span className={`
                    ml-2 px-2 py-0.5 rounded-full text-xs
                    ${activeFilter === filter.key
                      ? 'bg-indigo-700 text-white'
                      : 'bg-stone-200 text-stone-600'
                    }
                  `}>
                    {filter.count}
                  </span>
                )}
              </button>
            ))}
          </div>

          {/* Insights indicator */}
          {unreadInsights > 0 && (
            <div className="ml-auto flex items-center space-x-2 text-sm text-indigo-600">
              <div className="w-2 h-2 bg-indigo-500 rounded-full"></div>
              <span>{unreadInsights} new insights</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default IntelligenceFeedHeader;